module.exports = __webpack_public_path__ + "img/Shi.07a714d4.webp";